module.exports = __webpack_public_path__ + "./images/captchaimg.baaff0.gif";